import {removeAllQuerySelectionsAction} from '../actions';

export const removeAllSelectedQueries = (dispatch) => () => {
    dispatch(removeAllQuerySelectionsAction());
};
